import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Typography, Link } from "@material-ui/core";
import Logo from "./media/logo.png";
import SocialBar from "../socialBar/SocialBar";

const useStyle = makeStyles((theme) => ({
  logo: {
    width: "100px",
    objectFit: "cover",
    height: "auto",
    marginBottom: "1.2rem",
    borderRadius: "10%",
    [theme.breakpoints.down("sm")]: {
      width: "75px",
    },
  },
  styleLab: {
    fontSize: "0.7rem",
    fontWeight: "lighter",
    textDecoration: "none",
    color: theme.palette.secondary.main,
  },
  marginSet: {
    marginBottom: "1.2rem",
  },
}));

const FooterLeft = () => {
  const classes = useStyle();
  return (
    <Container>
      <img className={classes.logo} src={Logo} alt="Natakallam Logo"></img>
      <Typography className={classes.marginSet} variant="h5" color="primary">
        NaTakallam
      </Typography>
      <SocialBar marginBottom={"2rem"} />
      <Link
        className={classes.styleLab}
        href="https://www.re-coded.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Designed with love by Re:Coded Labs
      </Link>
    </Container>
  );
};

export default FooterLeft;
